import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from '../../Assets/logo.png';
import './slider.css';
import client from '../../Assets/icon/clients.svg';
import dashboard from '../../Assets/icon/dashboard.svg';
import product from '../../Assets/icon/product.svg';
import resellers from '../../Assets/icon/reseller.svg';
import profile from '../../Assets/icon/profile.svg';
import settings from '../../Assets/icon/settings.svg';
import selectICon from '../../Assets/select icon.svg';
import distributerIcon from '../../Assets/icon/distributer.svg';
import logoutIcon from '../../Assets/icon/logout.svg';
import amountransfer from '../../Assets/icon/amountransfer.svg';
import investment from '../../Assets/icon/investment.svg';
import api from "../../axiosInstance";
import Swal from "sweetalert2";



function Sidebar() {
  const session = () => {
    sessionStorage.clear();
  }

  const [hovered, setHovered] = useState(false);
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",  // blue
      cancelButtonColor: "#d33",      // red
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Logging out...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading(); // 👈 spinner
          },
        });
        try {
          await api.get("/logout"); // 👈 GET API call
          // Clear tokens/session
          localStorage.removeItem("token");
          sessionStorage.clear();
          window.location.href = "/login"; // redirect
        } catch (error) {
          Swal.fire("Error!", "Logout failed. Please try again.", "error");
        }
      }
    });
  };


  return (
    <div className="border border-end-1 outerShadow" style={{ width: "250px", background: 'white', color: "#fff" }}>
      <div><img src={Logo} alt="Logo" style={{ width: '85%', padding: '25px 0px' }} /></div>
      <nav>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <SidebarLink to="/dashboard" label="Dashboard" icon={dashboard} />
          <SidebarLink to="/product" label="Product" icon={product} />
          <SidebarLink to="/reseller" label="Resellers" icon={resellers} />
          <SidebarLink to="/client" label="Clients" icon={client} />
          <SidebarLink to="/profile" label="Profile" icon={profile} />
          {/* <SidebarLink to="/settings" label="Settings" icon={settings} /> */}
          <SidebarLink to="/distributer" label="Provider" icon={distributerIcon} />
          {/* <SidebarLink to="/investment" label="Investment" icon={investment} /> */}
          <SidebarLink to="/amountransfer" label="Amount Transfer" icon={amountransfer} />
          <li>
            <button
              onClick={(e) => {
                e.preventDefault();
                handleLogout();
              }}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              style={{
                ...linkStyle(hovered), // 👈 when hovered → active style
                background: "transparent",
                border: "none",
                width: "100%",
                textAlign: "left",
                cursor: "pointer",
              }}
            >
              <img
                src={logoutIcon}
                width={25}
                alt="logout"
                style={{
                  marginRight: 10,
                  marginLeft: 10,
                  filter: hovered ? activeFilter : inactiveFilter, // 👈 hover changes icon
                }}
              />
              Logout
            </button>
          </li>

        </ul>
      </nav>
    </div>
  );
}

// Reusable SidebarLink Component
const SidebarLink = ({ to, label, icon }) => {
  return (
    <li>
      <NavLink to={to} style={({ isActive }) => linkStyle(isActive)}>
        {({ isActive }) => (
          <>
            {isActive && <img src={selectICon} width={10} alt="Selected Icon" style={{ marginRight: 5, filter: activeFilter }} />}
            <img src={icon} width={25} alt={label} style={{ marginRight: 10, marginLeft: 10, filter: isActive ? activeFilter : inactiveFilter }} />
            {label}
          </>
        )}
      </NavLink>
    </li>
  );
};

// CSS Filters for SVG Color Change
//const activeFilter = "brightness(0) saturate(100%) invert(16%) sepia(20%) saturate(685%) hue-rotate(215deg) brightness(92%) contrast(92%)";
const inactiveFilter = "brightness(0) saturate(100%) invert(79%) sepia(7%) saturate(246%) hue-rotate(180deg) brightness(93%) contrast(91%)";
const activeFilter = "brightness(0) saturate(100%) invert(66%) sepia(35%) saturate(703%) hue-rotate(174deg) brightness(93%) contrast(94%)";

// Active and inactive link styling
const linkStyle = (isActive) => ({
  color: isActive ? "#6eb7ec" : "#a9afbb",
  textDecoration: "none",
  padding: "13px 0px",
  display: "flex",
  alignItems: "center",
  fontWeight: "900",
});

export default Sidebar;
